import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (password !== confirmPassword) {
      setError('As senhas não conferem.');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/auth/reset-password', { token, password });
      setMessage(response.data.message || 'Senha redefinida com sucesso!');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao redefinir a senha. O link pode estar expirado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Redefinir Senha</h2>
        <p style={styles.subtitle}>Digite sua nova senha abaixo.</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Nova senha:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            placeholder="Mínimo 6 caracteres"
          />

          <label style={styles.label}>Confirmar nova senha:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={styles.input}
            placeholder="Repita a nova senha"
          />

          {error && <p style={styles.error}>{error}</p>}
          {message && <p style={styles.success}>{message}</p>}

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Salvando...' : 'Salvar nova senha'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f3f5ff',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '22px',
    boxSizing: 'border-box',
  },
  card: {
    width: '340px',
    backgroundColor: '#fff',
    borderRadius: '20px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    padding: '24px',
    textAlign: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1f3b7d',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    margin: '0 0 20px 0',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '8px',
  },
  label: {
    textAlign: 'left',
    fontSize: '14px',
    color: '#444',
  },
  input: {
    height: '38px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    padding: '0 12px',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '10px',
  },
  button: {
    marginTop: '10px',
    backgroundColor: '#2a89ff',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '10px',
    height: '42px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  error: {
    fontSize: '13px',
    color: 'red',
    margin: '4px 0',
  },
  success: {
    fontSize: '13px',
    color: '#2e7d32',
    margin: '4px 0',
  },
};

export default ResetPassword;
